import { defineMessages } from 'react-intl'

export default defineMessages({
  changeMe: {
    id: 'components.PaymentMethods.GooglePay.changeMe',
    defaultMessage: '请修改',
    description: '请修改'
  },
  GooglePayUnavailable: {
    id: 'components.PaymentMethods.GooglePay.GooglePayUnavailable',
    defaultMessage: 'Google Pay is unavailable right now. Please choose another payment method.',
    description: 'Shown when Google Pay cannot open the payment sheet because of a configuration error',
  },
  GooglePayTryAgain: {
    id: 'components.PaymentMethods.GooglePay.GooglePayTryAgain',
    defaultMessage: 'Couldn’t open Google Pay. Please try again.',
    description: 'Shown when Google Pay failed for a potentially-transient reason (popup blocked, network error, BUYER_ACCOUNT_ERROR, INTERNAL_ERROR)',
  },
})
